/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SMTPSettingsResource } from '../models/SMTPSettingsResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SmtpSettingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les configurations SMTP
     * Le serveur d'envoi propre a chaque entreprise (`host`, `port`, `username`, `encryption`), utilise a la place du SMTP Solis quand il est defini.
     * @returns SMTPSettingsResource Array of `SMTPSettingsResource`
     * @throws ApiError
     */
    public adminSmtpIndex(): CancelablePromise<Array<SMTPSettingsResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/smtp',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Creer la configuration SMTP d'une entreprise
     * `customer_id`, `host`, `port`, `username`, `password`, `encryption`. Aucune validation ni test de connexion a la creation.
     * @returns SMTPSettingsResource `SMTPSettingsResource`
     * @throws ApiError
     */
    public adminSmtpStore(): CancelablePromise<SMTPSettingsResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/smtp',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Configuration SMTP d'une entreprise
     * Par `customer_id`. Si l'entreprise n'a pas de SMTP propre, renvoie la configuration Solis par defaut avec `is_default: true` et `password: null` — ce n'est pas une erreur.
     * @param customerId
     * @returns any
     * @throws ApiError
     */
    public adminSmtpShow(
        customerId: string,
    ): CancelablePromise<({
        id: null;
        customer_id: string;
        host: string;
        port: string;
        username: string;
        password: null;
        /**
         * Ne pas exposer le mot de passe par défaut
         */
        encryption: string;
        is_default: boolean;
    } | SMTPSettingsResource)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/smtp/{customer_id}',
            path: {
                'customer_id': customerId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier une configuration SMTP
     * Mise a jour partielle.
     * @param id
     * @returns SMTPSettingsResource `SMTPSettingsResource`
     * @throws ApiError
     */
    public adminSmtpUpdate(
        id: string,
    ): CancelablePromise<SMTPSettingsResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/smtp/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Supprimer une configuration SMTP
     * L'entreprise repasse sur le SMTP Solis.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminSmtpDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/smtp/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
